import { useEffect } from "react";

const RESERVE_URL =
  "https://www.kolayrandevu.com/reserve.php?salon=196179&greserve=1&utm_source=google&utm_medium=reserve_with_google&utm_content=action_url&rwg_token=AE37R_gY-0RYQVQuaFDzRIzkYdm1Tx3noKUCqXL-Sc4MfQqaKfdeAdFHLc-o2dU7S5AK1DDkwXs38LZ32MQadFzLyGGN1yyQJw%3D%3D";

export default function BookingPage() {
  useEffect(() => {
    window.location.replace(RESERVE_URL);
  }, []);
  return null;
}
